import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.808 5.024c.119.005.251.01.377.286.085.189.23.54.345.82.084.207.153.374.171.41.042.082.07.179.014.29l-.024.047c-.042.084-.072.146-.143.228l-.086.102c-.058.07-.116.139-.166.188-.084.083-.171.173-.073.338.097.166.434.708.932 1.147.535.471 1 .67 1.235.772.047.02.084.036.112.05.167.082.265.069.363-.042a9.69 9.69 0 00.53-.649c.112-.166.223-.138.377-.083.153.055.977.456 1.145.539l.091.044c.117.056.196.093.23.149.042.07.042.4-.098.787s-.824.76-1.13.787l-.09.01c-.284.033-.642.074-1.92-.424-1.574-.613-2.612-2.133-2.826-2.447a1.747 1.747 0 00-.036-.052l-.002-.003c-.09-.119-.682-.9-.682-1.71 0-.762.379-1.162.553-1.346l.033-.034a.619.619 0 01.447-.208h.018c.105 0 .21 0 .303.004z",
    fill: "#000",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.724 3.27a6.613 6.613 0 00-4.696-1.937c-3.66 0-6.638 2.963-6.64 6.606 0 1.165.306 2.301.887 3.303l-.942 3.424 3.52-.919c.969.527 2.06.804 3.172.804h.003c3.658 0 6.637-2.964 6.638-6.607 0-1.765-.689-3.425-1.942-4.674zM8.028 13.436h-.003a5.53 5.53 0 01-2.808-.766l-.202-.119-2.088.545.557-2.026-.13-.208A5.459 5.459 0 012.51 7.94c0-3.028 2.476-5.492 5.52-5.492 1.474.001 2.859.573 3.9 1.61a5.445 5.445 0 011.615 3.886c-.001 3.028-2.476 5.492-5.517 5.492z",
    fill: "#000",
    fillOpacity: 0.87
  }));
}
export default SvgComponent;